/*
    api接口统一管理
    export const apiAddress = p => get('xxx', p);
*/
import {
  get,post
} from '../request/http.js'

//测试接口
//export const test = k => post('/api/_demo.php?act=test', k);
//export const test = k => post('/api/_demo.php?act=test', k);

//var testhost = 'http://192.168.1.193:8087/';
//var testhost = 'http://1.62.163.250:8087';
var testhost = 'http://www.corner.com.cn';

//还需要修改ip地址的文件为:
// main.js 25行
// Contact.vue  88行
// Home.vue 70行
// JiFangHuanJingZiDongJianKongXiTong 66行
// ProductView 46行
// RuanJianChanPin 64行
// WuLianWangChanPin 66行
// XinFangYiTiJi  66行
// YingJianChanPin 66行

//export const test = k => post( testhost + '/project/content/list', k); //测试

//首页轮播图
export const HomeSlideBox = k => post( testhost + '/project/company/list?webType=109', k);
//首页解决方案
export const HomeJieJueFangAn = k => post( testhost + '/project/solution/list', k);
//首页媒体看凯纳
export const HomeMeiTiKanKaiNa = k => post( testhost + '/project/news/list?newsType=201', k);
//首页企业动态
export const HomeQiYeDongTai = k => post( testhost + '/project/news/list?newsType=203', k);
//首页典型案例
export const HomeChengGongAnLi = k => post( testhost + '/project/company/list?webType=104', k);
export const HomeChengGongAnLi_1 = k => post( testhost + '/project/company/list?webType=104&id=4', k); //哈尔滨智慧水务
export const HomeChengGongAnLi_2 = k => post( testhost + '/project/company/list?webType=104&id=24', k); //双鸭山市智慧水务
export const HomeChengGongAnLi_3 = k => post( testhost + '/project/company/list?webType=104&id=25', k); //佳木斯市智慧水务
export const HomeChengGongAnLi_4 = k => post( testhost + '/project/company/list?webType=104&id=26', k); //绥棱县智慧水务


export const GuanYuKaiNa = k => post( testhost + '/project/company/list?webType=101', k); //关于凯纳
export const ZiZhiRongYu = k => post( testhost + '/project/company/list?webType=108', k); //资质荣誉
export const QiYeWenHua = k => post( testhost + '/project/company/list?webType=105', k); //企业文化
export const SheHuiZeRen = k => post( testhost + '/project/company/list?webType=102', k); //社会责任
export const DangJianGongHui = k => post( testhost + '/project/company/list?webType=107', k); //党建工会
export const YuanGongFenCai = k => post( testhost + '/project/company/list?webType=103', k); //员工风采
export const ChengGongAnLi = k => post( testhost + '/project/company/list?webType=104', k); //典型案例
export const ChanPinJiYingYongShiPin = k => post( testhost + '/project/company/list?webType=111', k); //产品及应用视频

export const ArticleView = k => post( testhost + '/project/company/list', k); //文章详情页

export const MeiTiKanKaiNa = k => post( testhost + '/project/news/list?newsType=201', k); //媒体看凯纳
export const HangYeXinWen = k => post( testhost + '/project/news/list?newsType=202', k); //行业新闻
export const QiYeDongTai = k => post( testhost + '/project/news/list?newsType=203', k); //企业动态
export const TongZhiGongGao = k => post( testhost + '/project/news/list?newsType=204', k); //通知公告

export const XinWenView = k => post( testhost + '/project/news/list', k); //新闻详情页

export const ChanPinZhongXin = k => post( testhost + '/project/content/list', k); //产品中心

export const JieJueFangAn = k => post( testhost + '/project/solution/list', k); //解决方案

export const ZhiHuiXinFang = k => post( testhost + '/project/content/list', k); //智慧信访


export const JiShuZhiChi = k => post( testhost + '/project/technical/list', k); //技术支持

export const KeHuYuLianMeng = k => post( testhost + '/project/customers/list', k); //客户与联盟

export const RenCaiZhaoPin = k => post( testhost + '/project/talentrecruitment/list', k); //人才招聘
export const XiaoYuanZhaoPin = k => post( testhost + '/project/talentrecruitment/list?zplb=701', k); //校园招聘
export const SheHuiZhaoPin = k => post( testhost + '/project/talentrecruitment/list?zplb=702', k); //社会招聘

export const LiuYanBan = k => post( testhost + '/project/message/list', k); //留言板
export const LiuYanBan_add = k => post( testhost + '/project/message/add', k); //留言板提交
export const LiuYanBan_code = k => get( testhost + '/captcha/captchaImage?type=math', k); //留言板验证码




// WEBPACK FOOTER //
// ./src/request/api.js